import Quill from 'quill';

/** Quill font picker whitelist (toolbar value → CSS class ql-font-{value}) */
export const QUILL_FONT_WHITELIST = [
  '',
  'pretendard',
  'noto-sans-kr',
  'noto-sans',
  'noto-sans-jp',
  'noto-sans-thai',
  'noto-sans-khmer',
  'noto-sans-arabic',
  'nanum-gothic',
  'nanum-myeongjo',
  'nanum-pen-script',
] as const;

let isFontRegistered = false;

export const registerQuillFonts = () => {
  if (isFontRegistered) return;
  isFontRegistered = true;

  const Font = Quill.import('formats/font') as { whitelist: string[] };
  Font.whitelist = [...QUILL_FONT_WHITELIST];
  Quill.register('formats/font', Font as never, true);
};
